(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

function uniqueVals(arr) {
	var cleanVals = [];
	for (var y = 0; y < arr.length; y++) {
		if (cleanVals.indexOf(arr[y]) === -1 && arr[y] !== '') {
			cleanVals.push(arr[y]);
		}
	}

	return cleanVals;
}

function checkBox($target, $slide, optionIDs) {
	$target.children('.pl-option-upper').children('.pl-check-container').children('input').prop('checked', true);
	$target.children('.card-floorplan-lower').children('.pl-option-card-footer').children('button.btn-add').addClass('pl-added');
	$target.children('.card-floorplan-lower').children('.pl-option-card-footer').children('button.btn-add').text('Remove');

	$slide.children('.pl-scroller').children('.pl-slide-top').children('.pl-check-container').children('input').prop('checked', true);
	$slide.children('.pl-scroller').children('.pl-slide-bottom').children('button').addClass('pl-added');
	$slide.children('.pl-scroller').children('.pl-slide-bottom').children('button').text('Remove');

	optionIDs.push($target.attr('data-id'));

	$target.children('.btn-add').addClass('pl-added');

	//jQuery('.pl-option-modal .btn-add').addClass('pl-added');
	$target.addClass('option-checked');

	return optionIDs;
}

function uncheckBox($target, $slide, optionIDs) {
	$target.children('.pl-option-upper').children('.pl-check-container').children('input').prop('checked', false);
	$target.children('.card-floorplan-lower').children('.pl-option-card-footer').children('button.btn-add').text('Add');
	$target.children('.card-floorplan-lower').children('.pl-option-card-footer').children('button.btn-add').removeClass('pl-added');

	$slide.children('.pl-scroller').children('.pl-slide-top').children('.pl-check-container').children('input').prop('checked', false);
	$slide.children('.pl-scroller').children('.pl-slide-bottom').children('button').text('Add');
	$slide.children('.pl-scroller').children('.pl-slide-bottom').children('button').removeClass('pl-added');

	var arrIndex = $.inArray($target.attr('data-id'), optionIDs);

	if (arrIndex !== -1) {
		optionIDs.splice(arrIndex, 1);
	}

	$target.removeClass('option-checked');

	return optionIDs;
}

function checkOptionConflicts($target, conflicts, $optionEls, $slide, optionIDs, isChecked) {
	var returnIDs = [];

	if (isChecked) {
		for (var x = 0; x < conflicts.length; x++) {
			$('.card-floorplan[data-id="' + conflicts[x] + '"]').removeClass('conflict-option');
		}
	} else {
		for (var x = 0; x < conflicts.length; x++) {
			var $target = $('.card-floorplan[data-id="' + conflicts[x] + '"]');
			$target.addClass('conflict-option');
			if ($target.hasClass('option-checked')) {
				returnIDs = uncheckBox($target, $slide, optionIDs);
			}
		}
	}

	if (returnIDs.length > 0) {
		return returnIDs;
	} else {
		return optionIDs;
	}
}

function checkOptionDependencies($target, dependencies, $optionEls, $slide, optionIDs, isChecked) {
	var returnIDs = [];

	if (isChecked) {
		for (var x = 0; x < dependencies.length; x++) {
			var $target = $('.card-floorplan[data-id="' + dependencies[x] + '"]');
			if ($target.hasClass('require-option')) {
				returnIDs = uncheckBox($target, $slide, optionIDs);
			}

			$target.removeClass('require-option');
		}
	} else {
		for (var x = 0; x < dependencies.length; x++) {
			var $target = $('.card-floorplan[data-id="' + dependencies[x] + '"]');
			returnIDs = checkBox($target, $slide, optionIDs);
			$target.addClass('require-option');
		}
	}

	if (returnIDs.length > 0) {
		return returnIDs;
	} else {
		return optionIDs;
	}
}

jQuery(document).ready(function () {

	$('.pl-navNextBtn, .btn-next').removeClass('disabled');

	var currentParams = location.href.split('?')[1];
	var configData = JSON.parse(sessionStorage.getItem('configData'));
	setTimeout(function () {
		var paramArr = currentParams.split('&');
		if (paramArr.length >= 5) {
			var optionsList = decodeURIComponent(paramArr[4].split('=')[1]).split(',');
			for (var x = 0; x < optionsList.length; x++) {
				if (optionsList[x]) {
					jQuery('.card-floorplan[data-id="' + optionsList[x] + '"]').click();
				}
			}
		}
	}, 500);

	if (configData == null || configData == undefined || configData == 'undefined') {
		var configData = {};
		var params = currentParams.split('&');
		configData.model = params[0].split('=')[1];
		configData.color = params[1].split('=')[1];
		configData.floorplan = params[2].split('=')[1];
		configData.decor = params[3].split('=')[1];
		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));
	}

	configData.configStep = 'options';
	sessionStorage.setItem('configData', JSON.stringify(configData));
	localStorage.setItem('configData', JSON.stringify(configData));
	var selectedOptionIDs = [];

	jQuery('.card-floorplan').click(function (e) {
		e.preventDefault();
		var $target = $(this);

		if (jQuery(e.target).hasClass('pl-info') || jQuery(e.target).parent().hasClass('pl-info')) {
			return;
		}

		if ($target.hasClass('conflict-option')) {
			return;
		}

		var targetId = $target.attr('data-id');
		var targetIndex = $target.attr('data-index');
		var $targetSlide = jQuery('.pl-slide[data-id="' + targetId + '"]');
		var testSlide = jQuery('.pl-slide[data-id="' + targetId + '"]');
		var conflictList = [];

		if ($target.attr('data-conflict') != undefined) {
			conflictList = $target.attr('data-conflict').split('-');
		}

		var dependList = [];
		if ($target.attr('data-depend') != undefined) {
			dependList = $target.attr('data-depend').split('-');
		}
		var dependList = $target.attr('data-depend').split('-');
		var $allCards = jQuery('.card-floorplan');

		//if this is checked
		if ($target.children('.pl-option-upper').children('.pl-check-container').children('input').prop('checked')) {
			if (conflictList.length > 0) {
				selectedOptionIDs = checkOptionConflicts($target, conflictList, $allCards, $targetSlide, selectedOptionIDs, true);
			}

			if (dependList.length > 0) {
				selectedOptionIDs = checkOptionDependencies($target, dependList, $allCards, $targetSlide, selectedOptionIDs, true);
			}

			selectedOptionIDs = uncheckBox($target, $targetSlide, selectedOptionIDs);
			//if not checked then check it
		} else {
			if (conflictList.length > 0) {
				selectedOptionIDs = checkOptionConflicts($target, conflictList, $allCards, $targetSlide, selectedOptionIDs, false);
			}

			if (dependList.length > 0) {
				selectedOptionIDs = checkOptionDependencies($target, dependList, $allCards, $targetSlide, selectedOptionIDs, false);
			}

			selectedOptionIDs = checkBox($target, $targetSlide, selectedOptionIDs);
		}
	});

	jQuery('.pl-option-modal .btn-add, .pl-option-modal .pl-check-container').click(function (e) {
		e.preventDefault();
		var $this = $(this);
		var targetIndex = $this.parent().parent().parent().attr('data-id');
		var $targetSlide = jQuery('.pl-slide[data-id="' + targetIndex + '"]');
		var $targetCard = jQuery('.card-floorplan[data-id="' + targetIndex + '"]');
		var conflictList = [];

		if ($targetCard.attr('data-conflict') != undefined) {
			conflictList = $targetCard.attr('data-conflict').split('-');
		}

		var dependList = [];
		if ($targetCard.attr('data-depend') != undefined) {
			dependList = $targetCard.attr('data-depend').split('-');
		}

		var $allCards = jQuery('.card-floorplan');
		var $checkBox = $targetSlide.children().children('.pl-slide-top').children('.pl-check-container').children('input');

		//if checked uncheck
		if ($checkBox.prop('checked')) {
			if (conflictList.length > 0) {
				selectedOptionIDs = checkOptionConflicts($targetCard, conflictList, $allCards, $targetSlide, selectedOptionIDs, true);
			}

			if (dependList.length > 0) {
				selectedOptionIDs = checkOptionDependencies($targetCard, dependList, $allCards, $targetSlide, selectedOptionIDs, true);
			}

			selectedOptionIDs = uncheckBox($targetCard, $targetSlide, selectedOptionIDs);

			//it's not checked so check it
		} else {
			if (conflictList.length > 0) {
				selectedOptionIDs = checkOptionConflicts($targetCard, conflictList, $allCards, $targetSlide, selectedOptionIDs, false);
			}

			if (dependList.length > 0) {
				selectedOptionIDs = checkOptionDependencies($targetCard, dependList, $allCards, $targetSlide, selectedOptionIDs, false);
			}

			selectedOptionIDs = checkBox($targetCard, $targetSlide, selectedOptionIDs);
		}
	});

	$(".btn-option-more, .pl-option-image").click(function (e) {
		e.stopPropagation();

		if ($(this).hasClass('pl-option-image')) {
			var theParent = $(this).parent().parent();
		} else {
			var theParent = $(this).parent().parent().parent();
		}

		if ($(theParent).hasClass('conflict-option')) {
			return;
		}

		$('.pl-slide').hide();
		var target = $(this).attr('data-id');
		var screenWidth = window.innerWidth;
		var slickTo;
		var $modalTarget = $('.pl-swatch-modal-desktop');

		if (screenWidth < 900) {
			$modalTarget = $('.pl-swatch-modal-mobile');
		}

		$('.pl-slide').each(function (index) {
			if ($(this).attr('data-id') == target) {
				$(this).show();
			}
		});

		$('html').css('overflow-y', 'hidden');
		$modalTarget.addClass('activate');
		/*$('.pl-modal-slider').slick({
  	'initialSlide': slickTo,
  	'draggable': false,
  	'touchMove': false,
  	'swipe': false,
  	'swipeToSlide': false,
  	'arrows': false
  });
  $('.option-gallery-slider').slick({
  	'dots': false,
  	'arrows': true,
  	'swipe': true,
  	'swipeToSlide': true,
  	'draggable': true,
  	'touchMove': true
  });*/

		if ($(theParent).hasClass('option-checked')) {
			var slideIndex = $(theParent).attr('data-index');

			$('.pl-slide[data-slick-index="' + slideIndex + '"]').children('.pl-scroller').children('.pl-slide-top').children('.pl-check-container').children('input').prop('checked', true);
			$('.pl-slide[data-slick-index="' + slideIndex + '"]').children('.pl-scroller').children('.pl-slide-bottom').children('button').addClass('pl-added');
			$('.pl-slide[data-slick-index="' + slideIndex + '"]').children('.pl-scroller').children('.pl-slide-bottom').children('button').text('Remove');
		} else {
			var slideIndex = $(theParent).attr('data-index');

			$('.pl-slide[data-slick-index="' + slideIndex + '"]').children('.pl-scroller').children('.pl-slide-top').children('.pl-check-container').children('input').prop('checked', false);
			$('.pl-slide[data-slick-index="' + slideIndex + '"]').children('.pl-scroller').children('.pl-slide-bottom').children('button').text('Add');
			$('.pl-slide[data-slick-index="' + slideIndex + '"]').children('.pl-scroller').children('.pl-slide-bottom').children('button').removeClass('pl-added');
		}

		$('.slick-dots').on('click', 'li', function () {
			console.log('slick dot clicked');
			var index = $(this).children('button').attr('aria-label').split(' ')[0];
			index = index - 1;
			$('.option-gallery-slider').slick('slickGoTo', index);
		});
	});

	$(".pl-swatch-modal .pl-modal-close").click(function () {
		$(".pl-swatch-modal").removeClass("activate");
		$('.pl-modal-slider').slick('unslick');
		$('.option-gallery-slider').slick('unslick');
		$('body,html').css('overflow-y', 'scroll');
	});

	// $(".pl-swatch-modal .pl-modal-close").click(function(){
	//     $(".pl-swatch-modal").removeClass("activate");
	//   });

	// jQuery('.btn-option-more, .pl-option-image').click(function(e){
	// 	e.stopPropagation();
	// 	e.preventDefault();
	// 	jQuery('.pl-swatch-modal').addClass('activate');
	// 	jQuery('.pl-modal-slider').slick();
	// })


	jQuery('.pl-navNextBtn, .btn-next').click(function (e) {
		e.preventDefault();
		if (selectedOptionIDs) {
			selectedOptionIDs = uniqueVals(selectedOptionIDs);
			var currentParams = location.href.split('?')[1];
			var configData = JSON.parse(sessionStorage.getItem('configData'));
			var newParams = currentParams + '&options=' + selectedOptionIDs.join();

			//console.log(newParams);

			//NEED TO FILTER OUT DUPLICATES ON CLICK OFF
			// if(selectedOptionIDs.length > 0){
			// 	for(var x = 0; x < selectedOptionIDs.length; x++){
			// 		configData.addOns[x] = selectedOptionIDs[x];
			// 	}
			// }

			configData.options = selectedOptionIDs.join();
			localStorage.setItem('configData', JSON.stringify(configData));
			sessionStorage.setItem('configData', JSON.stringify(configData));
		} else {
			var newParams = currentParams + '&options=null';
			configData.options = null;
			sessionStorage.setItem('configData', JSON.stringify(configData));
			localStorage.setItem('configData', JSON.stringify(configData));
		}

		//console.log('navigating to summary');

		window.location.href = '/configurator/tc/add-ons/' + buildURLParams();
	});
});

},{}]},{},[1]);
